import { CONNECTION_HEALTH_FLAP_WINDOW_MS } from "~/context/call/connectionHealth/constants";

export const pruneFlapTimestamps = (
  timestamps: number[],
  nowMs: number,
  windowMs = CONNECTION_HEALTH_FLAP_WINDOW_MS
) => {
  const cutoff = nowMs - windowMs;
  return timestamps.filter((timestamp) => timestamp >= cutoff);
};

export const countFlapsInWindow = (
  timestamps: number[],
  nowMs: number,
  windowMs = CONNECTION_HEALTH_FLAP_WINDOW_MS
) => pruneFlapTimestamps(timestamps, nowMs, windowMs).length;

export const latestFlapTimestamp = (timestamps: number[]) => {
  if (timestamps.length === 0) return null;
  return Math.max(...timestamps);
};
